<div class="inner-block">
  <dot-loader
    [visibility]="show.loadingCustomers"
    description="Hämtar kund..."
  ></dot-loader>
  @if (!show.loadingCustomers) {
    <div class="account__card">
      <div class="float-end text--gray">
        @if (customer.crm_last_modified_at) {
          <p class="text--small">
            <span class="icon-refresh"></span> Uppdaterad i CRAM för
            <span>{{ cramUpdated }}</span>
          </p>
        }
        @if (customer.crm_last_synced_at) {
          <p class="text--small">
            <span class="icon-refresh"></span> Synkad från CRAM för
            <span>{{ cramSynced }}</span>
          </p>
        }
      </div>
      <h2>{{ customer.name }}</h2>
      @if (customer.locked) {
        <h3>
          Denna kund är låst och det går inte att boka kampanjer.
        </h3>
      }
      @if (!isAdminPlannerAccounting) {
        <h5>
          Hör av dig till din säljare om informationen nedan inte stämmer, så ser
          vi till att ändra den så snart som möjligt
        </h5>
      }
      <div class="row">
        <div class="col-sm-12 col-md-6">
          @if (customer.nickname && isAdminPlannerAccounting) {
            <div class="card__info">
              <span class="text--medium">Kundnamn TV4</span><br />
              <span>{{ customer.nickname || "-" }}</span>
            </div>
          }
          <div class="card__info">
            <div class="tab tab rounded">
              {{getCustomerType()}}
            </div>
            @if (customer.gambling_customer) {
            <div class="tab tab rounded">
              Spelbolag
            </div>
            }
            @if (customer.political_customer) {
              <div class="tab tab rounded">
                Politiskt parti
              </div>
            }
          </div>
          <div class="card__info">
            <span class="text--medium">Org. nr.</span><br />
            <span>{{ customer.org_no }}</span>
          </div>
          @if (isAdminPlannerAccounting) {
            <div class="card__info">
              <span class="text--medium">CRM-id</span><br />
              <span>{{ customer.crm_id || "-" }}</span>
            </div>
          }
          @if (isAdminPlannerAccounting) {
            <div class="card__info">
              <span class="text--medium">MRM-id</span><br />
              <span>{{ customer.mrm_id || "-" }}</span>
            </div>
          }
          @if (isAdminPlannerAccounting) {
            <div class="card__info">
              <span class="text--medium">TSC-id</span><br />
              <span>{{ customer.tsc_id || "-" }}</span>
            </div>
          }
          <div class="card__info">
            <span class="text--medium">Land, säte</span><br />
            <span>{{ customer.hq_country }}</span>
          </div>
          @if (customer.partner_agreements.length) {
            <div class="card__info">
              <span class="text--medium">Byråtillhörighet</span><br />
              <ul>
                @for(agreement of customer.partner_agreements; track $index) {
                  <li>
                    <a [routerLink]="['/agency', agreement.agency.id]">
                      <span>{{ agreement.agency.nickname }}</span>
                    </a>
                    <div>
                      @if (agreement.agency_type === 'media_agency') {
                        <span
                          >Mediebyrå.
                        </span>
                      }
                      @if (agreement.agency_type === 'digital_media_agency_with_discount') {
                        <span>
                            Digital mediebyrå med rabatt.
                        </span>
                      }
                      @if (agreement.agency_type === 'partner') {
                        <span>
                          Partner.
                        </span>
                      }
                      @if (otherAgency(agreement.agency_type)) {
                        <span>
                          Annanbyrå.
                        </span>
                      }
                      @if (agreement.valid_from) {
                        <span>
                          Från
                          <span>{{
                            agreement.valid_from | date: "yyyy-MM-dd"
                          }}</span>
                        </span>
                      }
                      @if (agreement.valid_to) {
                        <span>
                        till
                        <span>{{
                          agreement.valid_to | date: "yyyy-MM-dd"
                        }}</span>
                        </span>
                      }
                    </div>
                    @if (agreement.agency.locked) {
                      <span class="text--cta text--medium">
                        <span class="icon-warning"></span>
                        Denna byrå är låst
                      </span>
                    }
                  </li>
                }
              </ul>
            </div>
          }

          @if (customer.inactive_partner_agreements.length) {
            <div
              class="card__info"
            >
              <span class="text--medium">Tidigare byråer för kunden</span><br />
              <ul>
                @for(agreement of customer.inactive_partner_agreements; track $index) {
                <li>
                  <a [routerLink]="['/agency', agreement.agency.id]">
                    <span>{{ agreement.agency.name }}</span>
                  </a>
                  <div>
                    @if (agreement.agency_type === 'media_agency') {
                      <span>
                        Mediebyrå.
                      </span>
                    }
                    @if (agreement.agency_type === 'digital_media_agency_with_discount') {
                      <span>
                          Digital mediebyrå med rabatt.
                      </span>
                    }
                    @if(agreement.agency_type !== 'media_agency' &&
                    agreement.agency_type !==
                      'digital_media_agency_with_discount') {
                      <span>Annanbyrå.</span>
                    }
                    @if (agreement.valid_from) {
                      <span>
                        Från
                        <span>{{agreement.valid_from | date: "yyyy-MM-dd"}}</span>
                      </span>
                    }
                    @if (agreement.valid_to) {
                    <span>
                      till
                      <span>{{agreement.valid_to | date: "yyyy-MM-dd"}}</span>
                    </span>
                    }
                  </div>
                </li>
                }
              </ul>
            </div>
          }
          @if (activeBrands.length) {
            <div class="card__info">
              <span class="text--medium">Varumärken för kunden</span><br />
              <ul>
                @for(brand of activeBrands; track $index) {
                  <li>
                    <span>{{brand.name}}</span>
                  </li>
                }
              </ul>
            </div>
          }
          @if (inactiveBrands.length) {
            <div class="card__info">
            <span class="text--medium">Inaktiva varumärken för kunden</span><br />
            <ul>
              @for(brand of inactiveBrands; track $index) {
                <li>
                  <span>{{brand.name}}</span>
                </li>
              }
            </ul>
          </div>
        }
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="address__info section">
            <span class="text--medium">Faktureringsadress</span><br />
            <div>{{ customer.address_1 }}</div>
            @if (customer.address_2 !== null) {
                {{ customer.address_2 }}
                <span>{{ customer.zip_code }} </span>
                <span>{{ customer.city }}</span>
              <span>{{ customer.country }}</span>
            }
          </div>

          <div class="card__info">
            <span class="text--medium">God kreditvärdighet</span><br />
            <span
              class="status__badge with--icon small float--left margin-right--2x"
              [ngClass]="{
                success: !customer.low_credit_rating,
                error: customer.low_credit_rating
              }"
            ></span>
            @if(!customer.low_credit_rating) {
            <span>Ja</span>
            }
            @if(customer.low_credit_rating) {
            <span>Nej</span>
            }
          </div>
          <div class="card__info">
            <span class="text--medium">Betalningsvillkor</span><br />
            <span>{{ customer.payment_terms }} dagar</span>
            @if(customer.payment_terms_code) {
            <span> - {{ customer.payment_terms_code }}</span>
            }
          </div>
        </div>
      </div>

    <div class="row margin-top--4x">
      <div class="col">
        <h3>Avtal</h3>
      </div>
      <div class="col">
        <button
        class="button secondary float-end"
        (click)="show.endedDiscounts = !show.endedDiscounts">
        @if(!show.endedDiscounts) {
        <span>Visa</span>
        }
        @if(show.endedDiscounts) {
        <span>Dölj</span>
        }
        gamla rabatter/avtal
      </button>
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-12">
        <contract-discounts-list
          [contracts]="customer.contracts || []"
          [showEnded]="show.endedDiscounts"
        ></contract-discounts-list>
      </div>
    </div>

      <div class="row">
        <div class="col-sm-12">
          <h3>Ad Hoc-rabatter (Engång)</h3>
          <p>
            Gäller endast en bokning fr.o.m. dagen rabatten skapats och löpande.
          </p>
          <vouchers-list
            mode="edit"
            [vouchers]="customer.vouchers"
            [showUsedVouchers]="show.endedDiscounts"
            (onDelete)="onVoucherDestroy($event)"
          ></vouchers-list>
        </div>
        @if(!show.newVoucher && mayCreateDiscount) {
        <div class="col-sm-12">
          <button
            class="primary-1 button margin-top--2x"
            (click)="openNewVoucher()"
          >
            Skapa ny rabatt
          </button>
        </div>
        }
      </div>

      <div class="row">
        <div class="col-sm-12">
          <h3>Ad Hoc-rabatter (Period)</h3>
          <p>Obegränsad användning under alla periodens dagar.</p>
          <ad-hoc-contracts-list
            [contracts]="customer.ad_hoc_contracts"
            (onDelete)="onAdHocContractDestroy($event)"
            [showEnded]="show.endedDiscounts"
          ></ad-hoc-contracts-list>
        </div>
        @if(!show.newAdHocContract && mayCreateDiscount) {
        <div class="col-sm-12">
          <button
            class="primary-1 button margin-top--2x"
            (click)="openNewAdHocContract()"
          >
            Skapa ny rabatt
          </button>
        </div>
        }
      </div>
      @if(customer.cash_customer && mayBrowseAsCashCustomer) {
      <div class="row">
        <div class="col-sm-12">
          <h3>Cashkundsspecifikt</h3>
          <button
            type="button"
            class="button"
            [routerLink]="['/customer', customer.id, 'campaign']"
          >
            Boka cash-kampanj
          </button>
          <button
            type="button"
            class="button"
            [routerLink]="['/customer', customer.id, 'dashboard']"
          >
            Visa cashboard
          </button>
        </div>
      </div>
      }
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-6">
        <div class="tabbable__panel panel-padding clearfix shadow-z-1">
          <div class="col-sm-12">
            <h3><span class="icon-user"></span> Användare</h3>
          </div>
        </div>
        <div class="account__card margin--none padding--none clearfix">
          <table class="table table--woo table--hover">
            <tbody>
              @for(user of customer.users; track $index) {
                <tr>
                  <td>
                    <a
                      [routerLink]="['/user', user.id]"
                    >
                      {{ user.first_name }} {{ user.last_name }}
                    </a>
                  </td>
                </tr>
              }
              @for(user of customer.previous_agency_users; track $index) {
              <tr>
                <td>
                  <a
                    [routerLink]="['/user', user.id]"
                  >
                    {{ user.first_name }} {{ user.last_name }} (tidigare)
                  </a>
                </td>
              </tr>
              }
              @if(!customer.users.length && !customer.previous_agency_users.length) {
                <tr>
                  <td>
                    Inga användare kopplade till denna kund
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if(!customer.agencies.length && mayCreateNewUser) {
        <button class="button secondary float-end" (click)="openNewUser()" >
          Ny användare
        </button>
        }
      </div>

      @if(mayViewHistory) { 
        <div class="col-sm-12 col-lg-6">
          <div class="tabbable__panel panel-padding hadow-z-1">
            <div class="col-sm-12">
              <h3>Historik</h3>
            </div>
          </div>
          <div class="account__card margin--none clearfix">
            <history-list [items]="customerHistory"></history-list>
          </div>
        </div>
      }
    </div>
  }
  <div class="row">
    <div id="newItemInCustomer" class="col-sm-12">
      @if(show.newUser) {
      <div class="account__card">
        <h3>Skapa nytt användarkonto för {{ customer.name }}</h3>
        <form
          name="forms.newUserForm"
          (ngSubmit)="addUser(newUserObj, customer.id, customer.cash_customer)"
        >
          <div class="input__container">
            <label for="firstname">Förnamn *</label>
            <input
              id="firstname"
              name="firstName"
              type="text"
              [(ngModel)]="newUserObj.first_name"
            />
          </div>
          <div class="input__container">
            <label for="lastname">Efternamn *</label>
            <input
              id="lastname"
              name="lastName"
              type="text"
              [(ngModel)]="newUserObj.last_name"
            />
          </div>
          <div class="input__container">
            <label for="email">Email *</label>
            <input
              name="email"
              id="emailuser"
              type="email"
              [(ngModel)]="newUserObj.email"
              required
            />
          </div>
          <button type="submit" class="button primary-1">Skapa</button>
          <button type="button" class="link primary-1" (click)="closeNewUser()">
            Avbryt
          </button>
        </form>
      </div>
      }
    </div>
  </div>
</div>
